<template>
  <div class="join-ok">
    <img src="@/assets/img/login/join_ok.png" alt="" />
    <span class="mt-12 fonttwodark">加入成功</span>
    <span class="fontthreedark mt-12" v-if="isPhone"
      >为了获得更好的体验建议前往PC端进行登录</span
    >
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      isPhone: false,
    };
  },
  created() {
    this.isPC();
  },
  methods: {
    isPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = false;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > -1) {
          flag = true;
          break;
        }
      }
      this.isPhone = flag;
    },
  },
};
</script>
<style lang="scss">
.join-ok {
  width: 100%;
  height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>